import { ToggleButtonGroup } from "../core/components/toggleButtonGroup.js";
import { Button } from "../core/components/button.js";
import { ToggleButton } from "../core/components/toggleButton.js";
import { MultiSelect, MultiSelectProps } from "../core/components/multiSelect.js";
import { DropDownList, DropDownListProps } from "../core/components/dropDownList.js";
import { TimeSpanFilter } from "./timeSpanManager.js";
import { GraphicFocussingFilter, SearchType } from "./graphicFocussingManager.js";
import { BrowserStorageType, Helper } from "../core/util/helper.js";
import { ComponentHelper } from "../core/util/componentHelper.js";
import { Commands } from "../core/util/commandManager.js";
import { General } from "../../siteManagement/general.js";
import { SheetEventType, Sheet } from "../../siteManagement/sheet.js";
import { Config } from "../core/config/config.js";
import { ResourcePlanningSchedulerSettingsViewModel, ResourcePlanningSchedulerActions, ResourcePlanningSchedulerDataViewModel, ResourcePlanningSchedulerEventViewModel, ResourcePlanningSchedulerResourceViewModel, ResourceStatusSetting, DropDownFilterOptions } from "./resourcePlanningScheduler.js";
import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { ContextMenuItem, ContextMenu, ContextMenuItem as IContextMenuItem, ContextMenuButton } from "../core/components/contextMenu.js";
import { FixMode, MultiSelectAction } from "./multiselectHelper.js";
import IFrame, { IFrameProps } from "../core/components/iframe.js";
import { ExternalOpenerHelper } from "../core/util/externalOpenerHelper.js";
import { FavoriteFilter, FavoriteFilterManager } from "./favoriteFilterManager.js"
import { CheckBox } from "../core/components/checkBox.js";
import { OpenContainerFilterDialog } from "./dialogs/containerFilterDialog.js";
import { Legend } from './legend.js'
import { BaseComponentProps } from "../core/components/baseComponentProps.js";
import { CommandManagerAPI, StringKeyDictionary } from "../commonInterfaces.js";
import {
    ExtendedProjectFilter,
    ExtendedProjectFilterEntity,
    ExtendedProjectFilterProps,
    ProjectFilterHistoryItem
} from "./extendedProjectFilter.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import { Metadata } from "../core/components/commonApp.js";
import React from "react";
import ReactDOM from "react-dom";

export class Settings extends React.Component<SettingsProps, any> {
    private _timeSpanFilterRef: TimeSpanFilter = null;
    private readonly _sheetRef: JQuery;
    private _timeResolutionTypes = {
        "Hours": 0,
        "Days": 1,
        "Week": 2,
        "Month": 3
    }
    private _dataSources: any;
    private _currentSheet: Sheet = null;
    //private _lastChangeTimestamp = 0;
    private _supportedTemplateFilters: Array<SettingsKey> =
        ["AdrNrs", "FilterContainerWithEvents", "FilterContainerWithEvents", "FilterResourcesWithEvents", "SplitUpAndCutAssignment", "GrNrs", "KNrs", "OGrNrs", "ProjNrs", "RessNrs", "Resstand", "Restypes", "ShowExternalResources"];
    private _multiSelectActive: boolean;
    private _contextMenuRef: ContextMenu = null;
    private _externalOpenerMenuRef: ContextMenu = null;
    private _sheetId = null;
    constructor(props: SettingsProps) {
        super(props)
        this._currentSheet = General.Sheet.Manager.getTopMostSheet();
        this._sheetRef = this._currentSheet.elements.getLeftDrawerElementRef();
        this._dataSources = props.dataSources;
        this._onFilterValuesChanged();
        this._multiSelectActive = false;
        this.initApp();
    }

    private initApp = () => {
        $(document).on("keydown", (event) => {
            if (!this._sheetId || this._sheetId != General.Sheet.Manager.getTopMostSheet()?.id())
                return;

            switch (event.key) {
                case "Delete":
                    if (this._multiSelectActive)
                        this.props.actions.executeMultiSelectAction(MultiSelectAction.Delete);
                    else
                        this.props.actions.deleteEvent(null)
                    break;
            }
        })
    }

    private reloadResstypen = async (valueOGrNrs: any[]) => {
        const mainGroups = Array.isArray(valueOGrNrs) ?  valueOGrNrs.join(",") : valueOGrNrs;
        const data = await HTTPService.get("ResourceLookup/GetResstypen?mainGroups=" + encodeURIComponent(mainGroups))
        this._dataSources.resstypenDS.length = 0;
        for (let i = 0; i < data.length; i++) {
            this._dataSources.resstypenDS.push(data[i]);
        }
        this.props.commandManager.runCommand("Restypes", Commands.RELOADDATASOURCE);
    }

    private _handleOnChange = (field: { model: SettingsKey }, value: any, dataItem?: any) => {
        if (field.model == "Start" && value == null) {
            let now = new Date();
            let dt = new Date(now.getFullYear(), now.getMonth(), now.getDate());
            value = Helper.dates.getISODateString(dt);
        }
        else if (field.model == "OGrNrs" && value != null) {
            // Resstypen abhängig der ausgewählten Obergruppen laden
            this.reloadResstypen(value);
        }
        else if (field.model == "KNrGroups" && value != null) {
            // Kennungen auswählen zur ausgewählten Gruppe
            this.props.settings.KNrs = value.join().split(",").map(function (str: string) {
                return parseInt(str);
            });
        }
        else if (field.model == "FilteredFlags" && value != null) {
            this.props.settings.FilteredFlags = value;
        }
        else if (field.model == "AssignmentMoveVerticalFixed" && value) {
            this.props.settings.AssignmentMoveHorizontalFixed = false;
        }
        else if (field.model == "AssignmentMoveHorizontalFixed" && value) {
            this.props.settings.AssignmentMoveVerticalFixed = false;
        }
        else if (field.model == "ShowOnlyWorktime" && value) {
            this.props.actions.toggleCapacity(false);
        }
        else if (field.model == "GroupByResources" && value) {
            this.props.settings.GroupByAddresses = false;
            this.props.settings.GroupByProjects = false;
            this.props.settings.GroupByMachines = false;
            this.props.settings.AssignmentMoveHorizontalFixed = false;
            this.props.settings.AssignmentMoveVerticalFixed = false;
        }
        else if (field.model == "GroupByAddresses" && value) {
            this.props.settings.GroupByResources = false;
            this.props.settings.GroupByProjects = false;
            this.props.settings.GroupByMachines = false;
            this.props.settings.AssignmentMoveHorizontalFixed = true;
            this.props.settings.AssignmentMoveVerticalFixed = false;
            this.props.actions.toggleCapacity(false);
            this.props.settings.ShowUtilization = false;
            this.props.settings.FlagMode = 0;
            this.props.actions.toggleInteractiveSlotMode(false);
        }
        else if (field.model == "GroupByProjects" && value) {
            this.props.settings.GroupByResources = false;
            this.props.settings.GroupByAddresses = false;
            this.props.settings.GroupByMachines = false;
            this.props.settings.AssignmentMoveHorizontalFixed = true;
            this.props.settings.AssignmentMoveVerticalFixed = false;
            this.props.actions.toggleCapacity(false);
            this.props.settings.ShowUtilization = false;
            this.props.settings.FlagMode = 0;
            this.props.actions.toggleInteractiveSlotMode(false);
        }
        else if (field.model == "GroupByMachines" && value) {
            this.props.settings.GroupByResources = false;
            this.props.settings.GroupByAddresses = false;
            this.props.settings.GroupByProjects = false;
            this.props.settings.AssignmentMoveHorizontalFixed = true;
            this.props.settings.AssignmentMoveVerticalFixed = false;
            this.props.actions.toggleCapacity(false);
            this.props.settings.ShowUtilization = false;
            this.props.settings.FlagMode = 0;
            this.props.actions.toggleInteractiveSlotMode(false);
        }
        else if (field.model == "SlaViewActive" && value) {
            this.props.settings.FlagMode = 0;
            this.props.settings.AssignmentGroupingViewActive = false;
        }
        else if (field.model == "ShowProjectColor" && value) {
            this.props.settings.SlaViewActive = false;
            this.props.settings.FlagMode = 0;
            this.props.settings.AssignmentGroupingViewActive = false;
        } else if ((field.model === "FilterResourcesWithEvents")) {
            this.props.settings.OnlyContainerAssignments = false;
        } else if (field.model === "OnlyContainerAssignments") {
            this.props.settings.FilterResourcesWithEvents = false;
            this.props.settings.RessNrs = [];
        } else if (field.model === "FilterFlagOnlyInContainer" && value) {
            this.props.settings.ConsiderFlagsForTimePeriod = false;
        } else if (field.model === "ConsiderFlagsForTimePeriod" && value) {
            this.props.settings.FilterFlagOnlyInContainer = false;
        } else if (field.model === "KNrs" && value?.length === 0) {
            this.props.settings.FilterCodesOnlyInContainers = false;
        } else if (field.model === "ShowProjectStructure") {
            this.props.settings.ShowProjectStructure = value;
        } else if (field.model === "ProjectFilterShowAllAssignments" ) {
            this.props.settings.ProjectFilterShowAllAssignments = value;
        } 

        const changeData = this._getOnChangeData(field, value);
        if (changeData.changes.length > 1) {
            this._onFilterValuesChanged();
        }
        this.props.onChange(changeData.changes, changeData.values, dataItem);
    }

    private _toggleFlagView = (value: 0 | 1 | 2) => {
        if (value !== 0) {
            this.props.settings.ShowProjectColor = false;
            this.props.actions.toggleSlaView(false, false);
        }
        this.setState({}, () => {
            this.props.actions.toggleFlagView(value, true);
        })
    }

    private handleButtonClick = (type: "project" | "address" | "resource") => {
        if (type == "project") {
            let sheet: Sheet;
            if(Config.user.activeExtendedProjectFilter){
                async function buildHistoryGridData(history: ProjectFilterHistoryItem[], projNrs: string[]){
                    const allProjNrs = history.map(h => h.ProjNr).concat(projNrs);
                    const result = await HTTPService.post<JsonResultClass<any[]>>("ProjectLookup/GetProjects", {projNrs: allProjNrs});
                    if(result.Code === 0){
                        return result.Data.map(item => {
                            let historyItem = history.find(h => h.ProjNr == item.Projnr);
                            if(historyItem){
                                return $.extend({
                                    Active: historyItem.Active,
                                    CreateDate: historyItem.CreateDate
                                }, item);
                            }
                        });
                    }else{
                        NotificationHelper.showErrorMessage(result.Message);
                        return [];
                    }
                }
                HTTPService.chainBatch
                    .add<Metadata>(Helper.getMetaData("extendedProjectFilter"))
                    .add<JsonResultClass<FavoriteFilter[]>>("FavoriteFilter/GetAllForUser")
                    .promise()
                    .then((result) => {
                        sheet = General.Sheet.Manager.createSheet();
                        sheet.show(async () => {
                            const extendedProjFilter = Helper.loadDataFromStorage(Config.user.userName + "_ExtProjFilter");
                            let projNrs: string[] = [];
                            let history = [];
                            if(extendedProjFilter){
                                projNrs = extendedProjFilter.filter(h => h.Active);
                                history = extendedProjFilter;
                            }
                            const gridData = await buildHistoryGridData(history, projNrs);
                            let props : ExtendedProjectFilterProps = {
                                dataSources: {},
                                isWindow: false,
                                metadata: result[0],
                                entity: {
                                    IsNew: false,
                                    RecordRight: {
                                        CanRead: true,
                                        CanWrite: true,
                                        CanWritePermissionDeniedReason: ""
                                    },
                                    IsWatchable: false,
                                    IsWatched: false,
                                    ProjectFilterHistoryGridData: gridData,
                                    ProjectFilterHistory: history,
                                    ProjNrs: projNrs,
                                    ChoosedProjNrs: [],
                                    TakeOverProjectTimeSpans: false,
                                    ProjektfilterAlleEinsaetzeAnzeigen: this.props.settings.ProjectFilterShowAllAssignments,
                                    Active: this.props.settings.ActiveExtendedProjectFilter
                                },
                                context: {
                                    projectFilterHistoryGridOptions: {}
                                },
                                FavoriteFilterId: this.props.settings.FavoriteFilterId,
                                FavoriteFilterName: result[1].Code === 0 ? result[1].Data.find((filter: FavoriteFilter) => filter.Id === this.props.settings.FavoriteFilterId)?.Name : "???"
                            };
                            sheet.mountContent(ExtendedProjectFilter, props);
                        });
                        sheet.bind(SheetEventType.SavedSuccessfully, async(e: {entity: ExtendedProjectFilterEntity}) => {
                            Helper.saveDataToStorage(Config.user.userName + "_ExtProjFilter", e.entity.ProjectFilterHistory, false);
                            this._onFilterValuesChanged();
                            let changes: Array<OnChangeField> = [{model: "FavoriteFilterId"}, {model: "ProjectFilterShowAllAssignments"}, {model: "ActiveExtendedProjectFilter"}];
                            let values: Array<any> = [null, e.entity.ProjektfilterAlleEinsaetzeAnzeigen, e.entity.ProjNrs.length > 0];
                            if (e.entity.TakeOverProjectTimeSpans && e.entity.ProjNrs && e.entity.ProjNrs.length > 0) {
                                const result = await HTTPService.post<JsonResultClass<{
                                    Key: keyof ResourcePlanningSchedulerSettingsViewModel,
                                    Value: any
                                }[]>>('ResourcePlanning/GetProjectDates', {projNrs: e.entity.ProjNrs});
                                if (result.Code == 0) {
                                    let end = new Date(result.Data.find(d => d.Key == "End")?.Value);
                                    let start = new Date(result.Data.find(d => d.Key == "Start")?.Value);
                                    let diff = Math.abs(end.getTime() - start.getTime());
                                    let diffDays = Math.ceil(diff / (1000 * 3600 * 24));
                                    if (diffDays <= Config.user.projectRangeLimit) {
                                        changes.push({model: "FixedCellWidth"});
                                        changes.push({model: "DoNotChangeCellWidth"});
                                        changes.push({model: "TimeResolutionType"});
                                        changes.push({model: "CellWidth"});
                                        values.push(true);
                                        values.push(false);
                                        values.push(this.props.settings.TimeResolutionType);
                                        values.push(45);
                                        changes.push({model: "Start"});
                                        changes.push({model: "End"});
                                        values.push(result.Data.find(d => d.Key == "Start")?.Value);
                                        values.push(result.Data.find(d => d.Key == "End")?.Value);
                                        const scheduler = (window["dps"] as DayPilot.Scheduler);
                                        if (!this.props.settings.FixedCellWidth) {
                                            scheduler.cellWidthSpec = "Fixed";
                                            scheduler.cellWidth = 45;
                                            scheduler.update();
                                        }
                                        if (this.props.settings.TimeResolutionType > this._timeResolutionTypes.Days) {
                                            this.props.actions.toggleFlagView(0, false);
                                        }
                                        if (this.props.settings.TimeResolutionType === this._timeResolutionTypes.Hours) {
                                            this.props.actions.toggleCapacity(false);
                                        }
                                        setTimeout(() => {
                                            Helper.saveDataToStorage("timeSpanManager_fitToScreen", false, false);
                                            this._timeSpanFilterRef.update(false, this.props.settings.TimeResolutionType);
                                            this.props.onChange(changes, values, true);
                                        }, 500);
                                    } else {
                                        Helper.saveDataToStorage("timeSpanManager_fitToScreen", false, false);
                                        this._timeSpanFilterRef.update(false, this.props.settings.TimeResolutionType);
                                        changes.push({model: "FixedCellWidth"});
                                        values.push(true);
                                        const scheduler = (window["dps"] as DayPilot.Scheduler);
                                        scheduler.cellWidthSpec = "Fixed";
                                        scheduler.cellWidth = 45;
                                        scheduler.update();
                                        this.props.onChange(changes, values);
                                        setTimeout(() => {
                                                this._timeSpanFilterRef.openDialog(start, end);
                                        }, 500);
                                    }
                                } else {
                                    NotificationHelper.showErrorMessage(result.Message);
                                }
                            } else {
                                this.props.onChange(changes, values);
                            }
                        });
                    });
            }else{
                const dynamicSearchUrl = Config.baseUrl + "DynamicSearch/Window/Project?multi=true&displayPattern=[[projnr]]";
                sheet = General.Sheet.Manager.createSheetWithUrl(dynamicSearchUrl, null, { disableTabTitle: true });
                sheet.bind(SheetEventType.ItemsSelected, (e) => {
                    let currProjNrs = new Array<string>();
                for (let i = 0; i < e.data.length; i++) {
                        currProjNrs.push(e.data[i].projnr);
                    }
                    this._onFilterValuesChanged();
                    const changeData = this._getOnChangeData({ model: "ProjNrs" }, currProjNrs);
                    this.props.onChange(changeData.changes, changeData.values);
                if (currProjNrs.length == 0) {
                    this._handleOnChange({ model: "ProjectFilterShowAllAssignments"}, false)
                }


                    sheet.unbind(SheetEventType.ItemsSelected);
                });
                sheet.bind(SheetEventType.SetSelectedItems, (callback) => {
                    if (Helper.hasValue(callback)) {
                        let rawDS = [];
                    for (let i = 0; i < this.props.settings.ProjNrs.length; i++) {
                            let tmp = {};
                            tmp["projnr"] = this.props.settings.ProjNrs[i];
                            rawDS.push(tmp);
                        }
                        callback(rawDS);
                    }
                });
            }
        } else if (type === "address") {
            const dynamicSearchUrl = Config.baseUrl + "DynamicSearch/Window/Address?multi=true&displayPattern=[[adrnr]]";

            const sheet = General.Sheet.Manager.createSheetWithUrl(dynamicSearchUrl, null, { disableTabTitle: true });
            sheet.bind(SheetEventType.ItemsSelected, (e) => {
                let currAdrNrs: Array<string> = [];
                for (let i = 0; i < e.data.length; i++) {
                    currAdrNrs.push(e.data[i].adrnr);
                }
                this._onFilterValuesChanged();
                const changeData = this._getOnChangeData({ model: "AdrNrs" }, currAdrNrs);
                this.props.onChange(changeData.changes, changeData.values);
                sheet.unbind(SheetEventType.ItemsSelected);
            });
            sheet.bind(SheetEventType.SetSelectedItems, (callback) => {
                if (Helper.hasValue(callback)) {
                    let rawDS = [];
                    this.props.settings.AdrNrs.forEach(a => {
                        rawDS.push({ adrnr: a });
                    });
                    callback(rawDS);
                }
            });
        } else if (type === "resource") {
            const dynamicSearchUrl = Config.baseUrl + "DynamicSearch/Window/Resource?cus_disableRECHTPE=true&cus_disablePERSONALDATENRECHT=true&resstatus=0%20or%20null&disabled=resstatus&multi=true&displayPattern=[[ressnr]]";

            const sheet = General.Sheet.Manager.createSheetWithUrl(dynamicSearchUrl, null, { disableTabTitle: true });
            sheet.bind(SheetEventType.ItemsSelected, (e) => {
                let currRessNrs: Array<string> = [];
                for (let i = 0; i < e.data.length; i++) {
                    currRessNrs.push(e.data[i].ressnr);
                }
                this._onFilterValuesChanged();
                const changeData = this._getOnChangeData({ model: "RessNrs" }, currRessNrs);
                this.props.onChange(changeData.changes, changeData.values);
                sheet.unbind(SheetEventType.ItemsSelected);
            });
            sheet.bind(SheetEventType.SetSelectedItems, (callback) => {
                if (Helper.hasValue(callback)) {
                    let rawDS = [];
                    this.props.settings.RessNrs.forEach(r => {
                        rawDS.push({ ressnr: r });
                    });
                    callback(rawDS);
                }
            });
        }
    }

    private _setCommonPropValues = (props: BaseComponentProps, model: string, multiselect: boolean = true) => {
        props.field.model = model;
        props.field.name = model;
        if (!multiselect && Array.isArray(this.props.settings[model]) && this.props.settings[model].length > 0) {
            props.value = this.props.settings[model][0];
        } else
            props.value = this.props.settings[model];
        if (!Helper.hasValue(props.value)) {
            props.value = null;
        }
        props.onChange = this._handleOnChange;
    }

    private _wrapFilterComponent = (text: string, comp: any) => {
        return (
            <div style={{ width: "100%", marginTop: "10px", marginBottom: "3px" }}>
                <label>{text}</label>
                <div style={{ width: "100%", marginTop: "5px" }}>{comp}</div>
            </div>);
    }

    private _createSelectionFilterComponent = (model: string, label: string, multiselect: boolean, dataSource: any, dataSourceUrl: string, dataTextField: string, dataValueField: string, template: string = null): JSX.Element => {
        let props = multiselect ? ComponentHelper.createFactory().getDefaultMultiSelectProps()
            : ComponentHelper.createFactory().getDefaultDropDownProps()

        if (multiselect)
            (props as MultiSelectProps).field.primitiveValue = true;
        else
            (props as DropDownListProps).field.optionLabel = "";

        props.dataSource = dataSource;
        props.field.dataSourceUrl = dataSourceUrl
        props.field.dataTextField = dataTextField;
        props.field.dataValueField = dataValueField;
        props.field.template = template;
        props.commandManager = this.props.commandManager;
        props.disabled = false;//this.props.slotModeActive || this.props.interactiveSlotModeActive;

        this._setCommonPropValues(props, model, multiselect);
        return this._wrapFilterComponent(label, multiselect ? <MultiSelect {...props} /> : <DropDownList {...props} />);
    }

    private _createFlagFilter = () => {
        const props = ComponentHelper.createFactory().getDefaultMultiSelectProps();
        props.field.primitiveValue = true

        props.dataSource = this.props.settings.Flags;
        props.field.dataTextField = "Name";
        props.field.dataValueField = "Id";
        props.commandManager = this.props.commandManager;
        props.disabled = false;//this.props.slotModeActive || this.props.interactiveSlotModeActive;

        this._setCommonPropValues(props, "FilteredFlags");
        if (Helper.hasValue(this.props.settings.FilteredFlags) && this.props.settings.FilteredFlags.length > 0) {
            return this._wrapFilterComponent(this.props.translations["WebSMS.ResourcePlanningScheduler.Flags.Flags"], (
                <div style={{ display: "grid", gridTemplateRows: "auto 3px auto", gridTemplateColumns: "auto 3px auto 1fr" }}>
                    <div style={{ gridRow: "1/2", gridColumn: "1/5" }}>
                        <MultiSelect {...props} />
                    </div>
                    <div style={{ gridRow: "3/4", gridColumn: "1/2" }}>
                        {this._createToggleFilterComponent("FilterFlagOnlyInContainer", Helper.getTranslation("WebSMS.ResourcePlanningScheduler.Flags.FilterContainers"), null, false, "users-class")}
                    </div>
                    <div style={{ gridRow: "3/4", gridColumn: "3/4" }}>
                        {this._createToggleFilterComponent("ConsiderFlagsForTimePeriod", Helper.getTranslation("WebSMS.ResourcePlanningScheduler.Flags.ConsiderFlagsForTimePeriod"), null, false, "calendar-alt")}
                    </div>
                </div>
            ));
        } else {
            return this._wrapFilterComponent(this.props.translations["WebSMS.ResourcePlanningScheduler.Flags.Flags"], (
                <>
                    <MultiSelect {...props} />
                </>
            ));
        }
    }

    private _createCodeFilter = () => {
        const props = ComponentHelper.createFactory().getDefaultMultiSelectProps();
        props.field.primitiveValue = true

        props.field.dataTextField = this.props.dropDownFilterOptions.codes.dataSourceText;
        props.field.dataValueField = this.props.dropDownFilterOptions.codes.dataSourceKey;
        props.field.dataSourceUrl = this.props.dropDownFilterOptions.codes.url;
        props.field.template = this.props.dropDownFilterOptions.codes.template;
        props.commandManager = this.props.commandManager;
        props.disabled = false;//this.props.slotModeActive || this.props.interactiveSlotModeActive;

        this._setCommonPropValues(props, "KNrs");
        if (Helper.hasValue(this.props.settings.KNrs) && this.props.settings.KNrs.length > 0) {
            return this._wrapFilterComponent(this.props.translations["Field.Einsatz.kennung"], (
                <div style={{ display: "grid", gridTemplateRows: "auto 3px auto", gridTemplateColumns: "auto 3px auto 1fr" }}>
                    <div style={{ gridRow: "1/2", gridColumn: "1/5" }}>
                        <MultiSelect {...props} />
                    </div>
                    <div style={{ gridRow: "3/4", gridColumn: "1/2" }}>
                        {this._createToggleFilterComponent("FilterCodesOnlyInContainers", Helper.getTranslation("WebSMS.ResourcePlanningScheduler.Flags.FilterContainers"), null, false, "users-class")}
                    </div>
                </div>
            ));
        } else {
            return this._wrapFilterComponent(this.props.translations["Field.Einsatz.kennung"], (
                <>
                    <MultiSelect {...props} />
                </>
            ));
        }
    }

    private _createToggleFilterComponent = (model: string, title: string, iconText: string, readOnly: boolean, iconName: string = null): JSX.Element => {
        //TODO: nur auf Gruppen reagieren? 
        return <ToggleButton title={title} iconText={iconText} iconName={iconName} handleToggle={(value) => this._handleOnChange({ model: model as SettingsKey }, value)} initialValue={this.props.settings[model]} readOnly={readOnly /*|| this.props.slotModeActive || this.props.interactiveSlotModeActive*/} value={this.props.settings[model]} />;
    }

    private _onFilterValuesChanged = () => {
        //this._lastChangeTimestamp = new Date().getTime();
    }

    /*private _exhaustiveCheck = (prop: never): never => {
        throw new Error(`Property ${prop} was not handled.`);
    }*/

    private _getOnChangeData = (field: { model: SettingsKey }, value: any) => {
        const changes: Array<OnChangeField> = [];
        const values: Array<any> = [];

        if (this._supportedTemplateFilters.indexOf(field.model as SettingsKey) >= 0) {
            const property: SettingsKey = "SelectedFilterGuid";
            changes.push({ model: property });
            values.push(null);
        }

        changes.push(field);
        values.push(value);

        return { changes, values };
    }

    private _buildMulstiSelectMenu = (): ContextMenuItem[] => {
        let last = Helper.loadDataFromStorage("AssignentGroupingLastNew", BrowserStorageType.Session);
        if (last === undefined)
            last = 0;

        const items: IContextMenuItem[] = [
            {
                title: this.props.translations["WebSMS.ResourcePlanningScheduler.Multiselect.DeleteSelectedAssignments"],
                iconName: "trash-alt",
                onClick: () => {
                    this.props.actions.executeMultiSelectAction(MultiSelectAction.Delete);
                }
            },
            {
                title: "",
                splitter: true
            },
            {
                title: this.props.translations["WebSMS.ResourcePlanningScheduler.Multiselect.GroupSelectedAssignments"],
                iconName: "layer-group",
                items: [
                    {
                        title: this.props.translations["WebSMS.ResourcePlanning.GroupingNew"],
                        onClick: () => {
                            this.props.actions.processAssigmentGroupingList(MultiSelectAction.New);
                        }
                    },
                    {
                        title: Helper.getTranslation("WebSMS.ResourcePlaningGrouping.SelectLast").replace('{last}', last.toString()),
                        onClick: () => {
                            this.props.actions.processAssigmentGroupingList(MultiSelectAction.ChangeLast);
                        },
                        hidden: last == 0
                    },
                    {
                        title: this.props.translations["WebSMS.ResourcePlanning.GroupingSelect"],
                        onClick: () => {
                            this.props.actions.processAssigmentGroupingList(MultiSelectAction.Change);
                        }
                    }
                ]
            },
            {
                title: this.props.translations["WebSMS.ResourcePlanningScheduler.Multiselect.UngroupSelectedAssignments"],
                onClick: () => {
                    this.props.actions.processAssigmentGroupingList(MultiSelectAction.Delete);
                }
            }, {
                title: "",
                splitter: true
            }, {
                title: this.props.translations["WebSMS.ResourcePlanningScheduler.Multiselect.SelectedToContainer"],
                onClick: () => {
                    this.props.actions.executeMultiSelectAction(MultiSelectAction.MoveToContainer);
                }
            }, {
                title: this.props.translations["WebSMS.ResourcePlanningScheduler.Multiselect.AssignToRessource"],
                iconName: "person",
                onClick: () => {
                    this.props.actions.executeMultiSelectAction(MultiSelectAction.MoveToResource);
                }
            }, {
                title: "",
                splitter: true
            },
            {
                title: this.props.translations["WebSMS.ResourcePlanningScheduler.Multiselect.FilterProjects"],
                iconName: "folder",
                onClick: () => {
                    this.props.actions.executeMultiSelectAction(MultiSelectAction.FilterProjects);
                }
            }, {
                title: "",
                splitter: true
            }, {
                title: this.props.translations["WebSMS.ResourcePlanningScheduler.Multiselect.SetFixations"],
                iconName: "lock",
                items: [
                    {
                        title: this.props.translations["WebSMS.ResourcePlanningScheduler.Multiselect.SetFixations.FixStart"],
                        onClick: () => {
                            this.props.actions.executeMultiSelectFixing("fix", FixMode.Start)
                        }
                    },
                    {
                        title: this.props.translations["WebSMS.ResourcePlanningScheduler.Multiselect.SetFixations.FixEnd"],
                        onClick: () => {
                            this.props.actions.executeMultiSelectFixing("fix", FixMode.End)
                        }
                    }, {
                        title: this.props.translations["WebSMS.ResourcePlanningScheduler.Multiselect.SetFixations.FixRessource"],
                        onClick: () => {
                            this.props.actions.executeMultiSelectFixing("fix", FixMode.Ressource)
                        }
                    }, {
                        title: this.props.translations["WebSMS.ResourcePlanningScheduler.Multiselect.SetFixations.FixSE"],
                        onClick: () => {
                            this.props.actions.executeMultiSelectFixing("fix", FixMode.Start | FixMode.End)
                        }
                    }, {
                        title: this.props.translations["WebSMS.ResourcePlanningScheduler.Multiselect.SetFixations.FixAll"],
                        onClick: () => {
                            this.props.actions.executeMultiSelectFixing("fix", FixMode.Start | FixMode.End | FixMode.Ressource)
                        }
                    }
                ]
            },
            {
                title: this.props.translations["WebSMS.ResourcePlanningScheduler.Multiselect.UnlockFixation"],
                iconName: "lock-open",
                items: [
                    {
                        title: this.props.translations["WebSMS.ResourcePlanningScheduler.Multiselect.UnlockFixation.Start"],
                        onClick: () => {
                            this.props.actions.executeMultiSelectFixing("defix", FixMode.Start)
                        }
                    },
                    {
                        title: this.props.translations["WebSMS.ResourcePlanningScheduler.Multiselect.UnlockFixation.End"],
                        onClick: () => {
                            this.props.actions.executeMultiSelectFixing("defix", FixMode.End)
                        }
                    }, {
                        title: this.props.translations["WebSMS.ResourcePlanningScheduler.Multiselect.UnlockFixation.Resource"],
                        onClick: () => {
                            this.props.actions.executeMultiSelectFixing("defix", FixMode.Ressource)
                        }
                    },
                    {
                        title: this.props.translations["WebSMS.ResourcePlanningScheduler.Multiselect.UnlockFixation.SE"],
                        onClick: () => {
                            this.props.actions.executeMultiSelectFixing("defix", FixMode.Start | FixMode.End)
                        }
                    }, {
                        title: this.props.translations["WebSMS.ResourcePlanningScheduler.Multiselect.UnlockFixation.All"],
                        onClick: () => {
                            this.props.actions.executeMultiSelectFixing("defix", FixMode.Start | FixMode.End | FixMode.Ressource)
                        }
                    }
                ]
            }
        ];

        if (!this.props.settings.AssignmentGroupingActive)
            items.splice(1, 3);

        return items;
    }

    private _createContextMenu = () => {
        return (
            <>
                <ContextMenu
                    ref={(r) => this._contextMenuRef = r}
                    items={this._buildMulstiSelectMenu()}
                    target="multiselectButton"
                    showOn="click"
                />
            </>
        );
    }

    rebuildMultiSelectMenu = () => {
        this._contextMenuRef.rebuildItems(this._buildMulstiSelectMenu());
    }


    private _updateTimeSpan = (start: string | Date, end: string | Date, resolution: number, doNotChangeCellWidth: boolean = false, setSchedulertoStartDate: boolean = false) => {
        const tmpStart = typeof start === "string" ? start : Helper.dates.getISODateString(start);
        const tmpEnd = typeof end === "string" ? end : Helper.dates.getISODateString(end);
        if (Helper.dates.compareMultiTypeDates(tmpStart, this.props.settings.Start, true) !== 0 || Helper.dates.compareMultiTypeDates(tmpEnd, this.props.settings.End, true) !== 0 || this.props.settings.TimeResolutionType !== resolution) {
            const changes: Array<OnChangeField> = [{ model: "Start" }, { model: "End" }, { model: "TimeResolutionType" }, { model: "DoNotChangeCellWidth" }];
            const values: Array<any> = [tmpStart, tmpEnd, resolution, doNotChangeCellWidth, setSchedulertoStartDate];
            if (resolution > this._timeResolutionTypes.Days) {
                this.props.actions.toggleFlagView(0, false);
            }
            if (resolution === this._timeResolutionTypes.Hours) {
                this.props.actions.toggleCapacity(false);
            }
            this.props.onChange(changes, values, setSchedulertoStartDate);
            //if (!this.props.settings.AutomaticUpdate)
            //    this.props.actions.doRefresh();
        }
    }

    private _renderOpenExternalButton = () => {
        if (!Helper.hasValue(this.props.openExternalInfos) || this.props.openExternalInfos.length == 0) {
            return null;
        }
        const items: ContextMenuItem[] = this.props.openExternalInfos
            .filter(info => !Helper.isNullOrEmpty(info.statisticId) || !Helper.isNullOrEmpty(info.url))
            .map((info) => {
                return {
                    title: info.title,
                    onClick: this.openExternalStatisticFunction(info)
                }
            });

        return (
            <>
                <ContextMenuButton
                    buttonStyle={{ marginBottom: "10px" }}
                    iconName={"share-all"}
                    items={items}
                    showOn="click"
                />
            </>
        );

    }

    private openExternalStatisticFunction = (info: OpenExternalInfo) => {
        return () => {
            const params = ExternalOpenerHelper.mapToUrlParams(info.mapping, this.props.settings);

            let url: string;
            if (!Helper.isNullOrEmpty(info.statisticId)) {
                url = `${Config.baseUrl}Statistic/ShowNoIframe?statisticId=${info.statisticId}&${params.join("&")}`;
            } else if (!Helper.isNullOrEmpty(info.url)) {
                const c = info.url.indexOf("?") > -1 ? "&" : "?";
                url = `${Config.baseUrl}${info.url}${c}${params.join("&")}`;
            }

            if (!url)
                return;

            if (info.openInNewTab) {
                Helper.openInNewBrowserTab(url);
            } else {
                const sheet = General.Sheet.Manager.createSheet();
                const frameProps: IFrameProps = {
                    url: `${url}&kioskmode=true`
                }
                sheet.show(() => {
                    sheet.mountContent(IFrame, frameProps);
                })

            }
        }
    }


    componentDidMount() {
        this._sheetId = General.Sheet.Manager.getTopMostSheet()?.id();
        this.setState({});
    }

    private onFilterBtnClickFncFactory = (type: "project" | "address" | "resource") => {
        return (event: React.MouseEvent<HTMLDivElement>) => {
            if (event.ctrlKey) {
                if (Config.user.activeExtendedProjectFilter) {
                    let changes: Array<OnChangeField> = [{ model: "FavoriteFilterId" }, { model: "ProjectFilterShowAllAssignments" }, { model: "ActiveExtendedProjectFilter" }];
                    let values: Array<any> = [null, false, false];
                    this.props.onChange(changes, values)
                }


                let model: SettingsKey;
                switch (type) {
                    case "project":
                        model = "ProjNrs";
                        break;
                    case "address":
                        model = "AdrNrs";
                        break;
                    case "resource":
                        model = "RessNrs";
                        break;
                }

                const changeData = this._getOnChangeData({ model: model }, []);
                this.props.onChange(changeData.changes, changeData.values);
            } else {
                this.handleButtonClick(type);
            }
        }
    }

    private onFavoriteFilterChange = async (settings: ResourcePlanningSchedulerSettingsViewModel) => {
        if (settings == null)
        {
            await this.props.onFavoriteFilterChange(null);
            return;
        }

        const scheduler = (window["dps"] as DayPilot.Scheduler);
        const fitToScreen = !settings.FixedCellWidth;
        await this.props.onFavoriteFilterChange(settings);
        this._timeSpanFilterRef.update(fitToScreen, settings.TimeResolutionType);

        setTimeout(() => {
            if (fitToScreen) {
                scheduler.cellWidthSpec = "Auto";
            } else if (Helper.hasValue(settings.CellWidth)) {
                scheduler.cellWidthSpec = "Fixed";
                scheduler.cellWidth = settings.CellWidth;
            }
            scheduler.update();
        }, 25);
    }

    private createShowProjectStructureCheckBox = () => {
        if (!this.props.settings.GroupByProjects)
            return null;
        let props = ComponentHelper.createFactory().getDefaultCheckBoxProps();
        props.field.model = "ShowProjectStructure";
        props.field.labelAndControlCombined = true;
        props.field.name = Helper.getTranslation("Field.Projekt.ShowMainProject");
        props.value = this.props.settings.ShowProjectStructure;
        props.onChange = this._handleOnChange;
        return <div style={{ width: "100%" }}><CheckBox {...props} /></div>;
    }

    
    private eval = (value: any): boolean => {
        if (typeof (value) === "string" ) {
            const res = this.props.handleEval(value as string);
            //console.log("res=", res);
            return res as boolean;
        }
        return value;
    }

    render() {
        const dropDownOgrWrapped = this._createSelectionFilterComponent("OGrNrs", 
            this.props.translations["Einsatz.OGrNrFilter"],
            !(this.eval(this.props.dropDownFilterOptions.maingroups.multiselect) === false), 
            null, 
            this.props.dropDownFilterOptions.maingroups.url, 
            this.props.dropDownFilterOptions.maingroups.dataSourceText, 
            this.props.dropDownFilterOptions.maingroups.dataSourceKey, 
            this.props.dropDownFilterOptions.maingroups.template);
        const dropDownGrWrapped = this._createSelectionFilterComponent("GrNrs", 
            this.props.translations["Einsatz.GrNrFilter"],
            !(this.eval(this.props.dropDownFilterOptions.groups.multiselect) === false), 
            null, 
            this.props.dropDownFilterOptions.groups.url, 
            this.props.dropDownFilterOptions.groups.dataSourceText, 
            this.props.dropDownFilterOptions.groups.dataSourceKey, 
            this.props.dropDownFilterOptions.groups.template);

        const slotActive = false; //this.props.slotModeActive || this.props.interactiveSlotModeActive;
        
        let dropDownResstandWrapped = null;
        if (this.props.settings.Resstand_Enabled) {
            dropDownResstandWrapped = this._createSelectionFilterComponent("Resstand", this.props.translations["Field.Ressource.ressstand"], true, null, "ResourceLookup/GetLocations", "Bemerkung", "Ressstand");
        }
        let dropDownKNrGroupsWrapped = null;
        if (this.props.settings.KNrGroups_Enabled)
            dropDownKNrGroupsWrapped = this._createSelectionFilterComponent("KNrGroups", this.props.translations["Einsatz.ProjektkennungGruppe"], true, null, "ResourcePlanningLookup/GetKennungGruppen", "Name", "Value");

        let dropDownKNrsWrapped = null;
        if (this.props.settings.KNrs_Enabled)
            dropDownKNrsWrapped = this._createCodeFilter();
        let multiselectFlagsWrapped = null;
        if (Config.settings.flagsAreActive && this.props.settings.FlagFilter_Enabled) {
            multiselectFlagsWrapped = this._createFlagFilter();
        }

        let multiselectIconsWrapped = null;
        if (Config.user.iconsAreActive && this.props.settings.IconFilter_Enabled) {
            multiselectIconsWrapped = this._createSelectionFilterComponent("FilteredIcons", Helper.getTranslation("WebSMS.ResourcePlanningScheduler.Icon.Icons"), true, null, "Icon/GetAsDataSource", "Name", "Id", 
                "<table style='border-collapse:collapse; border-spacing:0; table-layout:fixed; width:150px'><colgroup><col style='width: 125px' /><col style='width: 25px' /></colgroup><tr style='background-color:inherit'><td style='vertical-align:top'>${data.Name}</td><td style='vertical-align:top'><span style='margin-left: 5px; color: {data.Color};'>&\\#x${data.HexCode}</span></td></tr></table>");
        } //TODO: Check {data.Color}

        let dropDownRestypesWrapped = null;
        if (this.props.settings.Restypes_Enabled) {
            dropDownRestypesWrapped = this._createSelectionFilterComponent("Restypes", this.props.translations["Field.Ressource.resstyp"], true, this.props.dataSources.resstypenDS, null, "Value", "Key");
        }

        let dropDownResourceStatusWrapped = null;
        if (this.props.settings.ResourceStatusEnabled) {
            const dataSource = [
                {
                    Key: ResourceStatusSetting.All,
                    Value: Helper.getTranslation("Standard.Alle")
                },
                {
                    Key: ResourceStatusSetting.Active,
                    Value: Helper.getTranslation("Ressource.Aktiv")
                },
                {
                    Key: ResourceStatusSetting.Inactive,
                    Value: Helper.getTranslation("Ressource.Passiv")
                }
            ];
            dropDownResourceStatusWrapped = this._createSelectionFilterComponent("ResourceStatusSetting", Helper.getTranslation("WebSMS.Resource.ResourceStatus"), false, dataSource, null, "Value", "Key");
        }

        const toggleFilterResourceWithEventWrapped = this._createToggleFilterComponent("FilterResourcesWithEvents", this.props.translations["Einsatz.FilternRessourceHint"],
            this.props.translations["Einsatz.FilternRessourceText"], false);
        const toggleFilterContainerWithEventWrapped = this._createToggleFilterComponent("FilterContainerWithEvents", this.props.translations["Einsatz.FilternContainerHint"],
            this.props.translations["Einsatz.FilternContainerText"], false);

        let toggleHideExternalResourcesWrapped = null;
        if (this.props.settings.HideExternalResources_Enabled) {
            toggleHideExternalResourcesWrapped = this._createToggleFilterComponent("ShowExternalResources", this.props.translations["Einsatz.ShowExternalResourcesHint"],
                    /*this.props.translations["Einsatz.HideExternalResources"]*/ null, false, "handshake-alt");
        }

        const toggleAutomaticUpdateWrapped = null;
            //this._createToggleFilterComponent("AutomaticUpdate", this.props.translations["Einsatz.AutomaticUpdateHint"],
            //this.props.translations["Einsatz.AutomaticUpdate"], false);

        let toggleShowProjectColorWrapped = null;
        if (this.props.settings.ShowProjectColor_Enabled) {
            toggleShowProjectColorWrapped = this._createToggleFilterComponent("ShowProjectColor", this.props.translations["Einsatz.ProjektfarbeAnzeigenHint"],
                this.props.translations["Einsatz.ProjektfarbeAnzeigenText"], false);
        }

        let toggleAssignmentMoveVerticalFixedWrapped = null;
        if (this.props.settings.GroupByResources) {
            toggleAssignmentMoveVerticalFixedWrapped = this._createToggleFilterComponent("AssignmentMoveVerticalFixed", this.props.translations["Einsatz.Einstellungen.AssignmentMoveVerticalFixedHint"],
                null, false, "arrows-v");
        }
        let toggleAssignmentMoveHorizontalFixedWrapped = null;
        if (this.props.settings.GroupByResources) {
            toggleAssignmentMoveHorizontalFixedWrapped = this._createToggleFilterComponent("AssignmentMoveHorizontalFixed", this.props.translations["Einsatz.Einstellungen.AssignmentMoveHorizontalFixedHint"],
                null, false, "arrows-h");
        }

        const toggleWholeDayAssignmentRendering = this.props.settings.TimeResolutionType === this._timeResolutionTypes.Days ? this._createToggleFilterComponent("WholeDayAssignmentRendering", this.props.translations["WebCRM.Administration.WholeDayAssignmentRendering"],
            null, false, "columns") : null;

        let toggleShowAssignmentsWithTimeZones = null;
        if (this.props.settings.ShowAssignmentsWithTimeZones_Enabled) {
            toggleShowAssignmentsWithTimeZones = this._createToggleFilterComponent("ShowAssignmentsWithTimeZones", this.props.translations["WebSMS.ResourcePlanning.ShowAssignmentsWithTimezones"],
                null, false, "clock");
        }

        let toggleShowOnlyWorktimeWrapped = null;
        const filterResourceForWorktime = (resource: ResourcePlanningSchedulerResourceViewModel) => {
            return resource.Id.includes("r|") && Helper.hasValue(resource.WochenendId) && (this.props.settings.AllWeekendDays.findIndex(schema => schema.Id == resource.WochenendId) > -1);
        }

        if (this.props.settings.AllWeekendDays.length == 0 || this.props.data.Resources.filter(filterResourceForWorktime).length === 0) {
            toggleShowOnlyWorktimeWrapped = this._createToggleFilterComponent("ShowOnlyWorktime", this.props.translations["WebSMS.ResourcePlanningScheduler.ShowOnlyWorktime"],
                null, false, "business-time");
        }

        let toggleProjectFilterShowAllAssignments = !Helper.hasValue(this.props.settings.ProjNrs) || this.props.settings.ProjNrs.length == 0 ? null : 
            <ToggleButton title={this.props.translations["Projekt.ProjectFilterShowAllAssignments"]}
                          initialValue={this.props.settings.ProjectFilterShowAllAssignments} 
                          value={this.props.settings.ProjectFilterShowAllAssignments} 
                          handleToggle={(value) => this._handleOnChange({ model: "ProjectFilterShowAllAssignments" as SettingsKey }, value)}
                          iconName={"folder-plus"} 
                          readOnly={slotActive || this.props.settings.ProjNrs.length === 0} />;
//         
        let projectFilterTranslationKey = Config.user.activeExtendedProjectFilter ? "Projekt.ExtendedProjektfilter" : "Projekt.Projektfilter";
        let inactiveStateProjectFilterBtn: boolean =
            (Config.user.activeExtendedProjectFilter &&
                ((Helper.hasValue(this.props.settings.FavoriteFilterId) && this.props.settings.ProjNrs.length === 0) ||
                    (!Helper.hasValue(this.props.settings.FavoriteFilterId) && !this.props.settings.ActiveExtendedProjectFilter))) ||
            (!Config.user.activeExtendedProjectFilter && this.props.settings.ProjNrs.length === 0);
        let buttonProjectFilter =
            <Button title={this.props.translations[projectFilterTranslationKey]} inactiveState={inactiveStateProjectFilterBtn} handleClick={this.onFilterBtnClickFncFactory("project")} iconName = { "folder-open"} readOnly= {slotActive} throttleActive={true}/>;

        let buttonAddressFilter =
            <Button title={this.props.translations["Adresse.AddressFilter"]} inactiveState={this.props.settings.AdrNrs.length === 0} handleClick={this.onFilterBtnClickFncFactory("address")} iconName={"home"} readOnly={slotActive} throttleActive={true} />;
        const iconRess = this.props.settings.ResourceFilterExclusive ? "person-circle-plus" : "child";
        const hintRess = this.props.settings.ResourceFilterExclusive ? 
            Helper.getTranslation("Ressource.RessourcenFilterExclusive") : this.props.translations["Ressource.RessourcenFilter"];
        let buttonResourceFilter = 
            <Button title={hintRess} 
                    inactiveState={this.props.settings.RessNrs.length === 0} 
                    handleClick={this.onFilterBtnClickFncFactory("resource")} 
                    iconName={iconRess} 
                    throttleActive={true}
                    readOnly={slotActive || this.props.settings.OnlyContainerAssignments} />;

        const buttonContainerFilter = /*this.props.settings.CrossDbPlanningBoard && */!this.props.settings.GroupByResources ? null
            : <Button title={Helper.getTranslation("WebSMS.ResourcePlanningScheduler.ContainerFilter.Id")} inactiveState={!Helper.hasValue(this.props.settings.ContainerFilterId) && !Helper.isNumber(this.props.settings.ContainerFilterId)} handleClick={async () => {
                const id = await OpenContainerFilterDialog(this.props.settings.ContainerFilterId)
                this.props.actions.setContainerFilterId(id);
            }} iconName={"user-group"} />;

        //this._createToggleFilterComponent("OnlyUnfinished", "OnlyUnfinished***", null, false, "flag-checkered");
        const toggleOnlyUnfinshed = <ToggleButton layerIcons={[{ name: "flag-checkered fa-stack-1x" }, { name: "ban fa-stack-2x", style: { fontSize: "1.75em", transform: "translate(0, 2px)" } }]} title={Helper.getTranslation("WebSMS.ResourcePlanningScheduler.OnlyUnfinished")} handleToggle={(value) => this._handleOnChange({ model: "OnlyUnfinished" as SettingsKey }, value)} initialValue={this.props.settings.OnlyUnfinished} readOnly={false} value={this.props.settings.OnlyUnfinished} />; 
        const onlyContainers = this._createToggleFilterComponent("OnlyContainerAssignments", this.props.translations["WebCRM.Administration.OnlyContainers"], null, false, "users-class");

        const toggleCapacity = (this.props.settings.ShowOnlyWorktime || !this.props.settings.GroupByResources || this.props.settings.TimeResolutionType === this._timeResolutionTypes.Hours) ? null :
            <ToggleButton title={this.props.translations["Kapazitaet.Toggle"]} initialValue={this.props.settings.DisplayCapacityChart} value={this.props.settings.DisplayCapacityChart} handleToggle={(value) => { this.props.actions.toggleCapacity(value) }} iconName={"chart-bar"} readOnly={slotActive} />;

        //Todo: disable slot-search after worklist was closed
        const toggleWorklistInTable = <ToggleButton
            title={this.props.translations["WebSMS.ResourcePlanningScheduler.ShowWorkListAsTable"]} initialValue={this.props.settings.DisplayWorkListInTable} value={this.props.settings.DisplayWorkListInTable}
            handleToggle={(value) => { this.props.actions.toggleWorklistInTable(value) }} iconName={"table"} readOnly={false /*this.props.slotModeActive && !this.props.interactiveSlotModeActive*/} />;

        let toggleSlaView = null;
        if (Config.user.slaManagementRight)
            toggleSlaView = <ToggleButton title={this.props.translations["WebSMS.SLA.ResourcePlanning.SlaView"]} initialValue={this.props.settings.SlaViewActive} value={this.props.settings.SlaViewActive} handleToggle={(value) => { this.props.actions.toggleSlaView(value, true) }}
                iconName={"file-contract"} readOnly={false/*this.props.slotModeActive && this.props.settings.FlagMode != 0*/} />;

        const activeView = Config.settings.flagsAreActive && this.props.settings.GroupByResources && (this.props.settings.TimeResolutionType <= this._timeResolutionTypes.Days);

        const toggleFlagGantView = activeView ? <ToggleButton title={this.props.translations["WebSMS.ResourcePlanningScheduler.Flags.CellInFlagColor"]} initialValue={this.props.settings.FlagMode >= 1} value={this.props.settings.FlagMode >= 1} handleToggle={(value) => { this._toggleFlagView(value ? 1 : 0) }}
            iconName={"flag"} readOnly={/*this.props.slotModeActive || */(this.props.settings.TimeResolutionType > this._timeResolutionTypes.Days)} /> : null;

        const toggleFlagAssignmentView = activeView ? <ToggleButton title={this.props.translations["WebSMS.ResourcePlanningScheduler.Flags.AssignmentsInFlagColor"]} initialValue={this.props.settings.FlagMode == 2} value={this.props.settings.FlagMode == 2} handleToggle={(value) => { this._toggleFlagView(value ? 2 : 1) }}
            iconName={"flag"} prefix={"fas"} readOnly={/*this.props.slotModeActive || */(this.props.settings.TimeResolutionType > this._timeResolutionTypes.Days)} /> : null;


        const toggleAssigmentGroupingView = this.props.settings.AssignmentGroupingActive ? <ToggleButton title={this.props.translations["WebSMS.ResourcePlanning.AssigmentGroupingView"]} initialValue={this.props.settings.AssignmentGroupingViewActive} value={this.props.settings.AssignmentGroupingViewActive} handleToggle={(value) => { this.props.actions.toggleAssigmentGroupingView(value) }}
            iconName={"layer-group"} readOnly={false/*this.props.slotModeActive*/} /> : null;

        const toggleUtilization = ((this.props.settings.TimeResolutionType === this._timeResolutionTypes.Hours) || (this.props.settings.TimeResolutionType === this._timeResolutionTypes.Days)
            && this.props.settings.GroupByResources) ? this._createToggleFilterComponent("ShowUtilization", this.props.translations["WebSMS.ResourcePlanningScheduler.ShowUtilization"], null, false, "percent") : null;
        const toggleTargetPeriods = this._createToggleFilterComponent("ShowTargetPeriods", this.props.translations["WebSMS.ResourcePlanningScheduler.ShowTargetPeriods"], null, false, "arrow-to-right");
        const toggleDegreeOfCompletion = this._createToggleFilterComponent("ShowDegreeOfCompletion", this.props.translations["WebSMS.ResourcePlanningScheduler.ShowDegreeOfCompletion"], null, false, "history");

        const settings = this.props.settings;
        const dataSettings = this.props.data.SettingsPlanningBoard;
        let navDiv = null;

        const navigationDiv = $('[data-resource-planning-scheduler-navigation="1"]');
        if (navigationDiv && navigationDiv.length > 0) {
            let div =
                <div style={{ display: "flex", alignItems: "center", padding: "10px 10px 0 10px", flexWrap: "wrap" }}>
                    <Button buttonStyle={{ marginBottom: "10px", borderRadius: "var(--border-radius)" }} title={this.props.translations["MonitorBaum.NeuLaden"]} handleClick={this.props.actions.doRefresh} iconName={"sync"} readOnly={slotActive} />
                    <TimeSpanFilter
                        start={settings.Start} end={settings.End} translations={this.props.translations} timeResolutionType={settings.TimeResolutionType}
                        nextStart={dataSettings.NextDate} nextEnd={dataSettings.NextEndDate} prevStart={dataSettings.PrevDate}
                        prevEnd={dataSettings.PrevEndDate} nextCustomStart={dataSettings.NextCustomDate} nextCustomEnd={dataSettings.NextCustomEndDate}
                        prevCustomStart={dataSettings.PrevCustomDate} prevCustomEnd={dataSettings.PrevCustomEndDate}
                        todayStart={dataSettings.Today} todayEnd={dataSettings.TodayEndFrameDate} fitToScreen={Helper.isNullOrEmpty(this.props.settings.FavoriteFilterId) ? null : !this.props.settings.FixedCellWidth}
                        zoomInStart={dataSettings.ZoomInStartDate} zoomInEnd={dataSettings.ZoomInEndDate} zoomOutStart={dataSettings.ZoomOutStartDate}
                        zoomOutEnd={dataSettings.ZoomOutEndDate} onTimeSpanChanged={this._updateTimeSpan}
                        fixedCellWidth={this.props.data.SettingsPlanningBoard.CellWidth} ref={(ref) => { this._timeSpanFilterRef = ref; }}
                        disabled={slotActive}
                    />
                    <GraphicFocussingFilter
                        onNavigateBackward={this.props.onGraphicalFocussingChange.onBackward}
                        onNavigateForward={this.props.onGraphicalFocussingChange.onForward}
                        onValueChange={this.props.onGraphicalFocussingChange.onChange}
                        groupedByResource={this.props.settings.GroupByResources}
                    />
                    <FavoriteFilterManager
                        settings={this.props.settings}
                        onChange={this.onFavoriteFilterChange}
                        favoriteFilterId={this.props.settings.FavoriteFilterId}
                    />
                    {this._renderOpenExternalButton()}
                </div>
            navDiv = ReactDOM.createPortal(div, navigationDiv[0]);
        }

        // @ts-ignore
        const sectionLabelStyle: React.CSSProperties = {
            fontWeight: "bold",
            marginTop: "30px",
            width: "100%"
        };

        // @ts-ignore
        const buttonGroupStyle: React.CSSProperties = {
            width: "100%",
            marginTop: "10px",
            marginBottom: "3px",
            display: "flex"
        };

        // @ts-ignore
        const inlineButtonGroupStyle: React.CSSProperties = {
            marginTop: "10px",
            marginBottom: "3px",
            marginRight: "10px",
            display: "flex"
        };
        let portal =
            <div style={{ margin: "5px", marginRight: "8px", display: "flex", flexWrap: "wrap" }} >
                {navDiv}
                <FilterGroup index={0} name={this.props.translations["WebSMS.ResourcePlanning.FilterRows"]} id="filterRows" initalOpen={true} >
                    {dropDownOgrWrapped}
                    {dropDownGrWrapped}
                    {dropDownResstandWrapped}
                    {dropDownRestypesWrapped}
                    {dropDownResourceStatusWrapped}
                    <ToggleButtonGroup style={buttonGroupStyle}>
                        {toggleFilterResourceWithEventWrapped}
                        {toggleFilterContainerWithEventWrapped}
                        {toggleHideExternalResourcesWrapped}
                        {buttonResourceFilter}
                        {onlyContainers}
                    </ToggleButtonGroup>

                    <ToggleButtonGroup>

                        {this.props.settings.ReadOnlyScheduler ? <></> :
                            <>
                                <ToggleButton
                                    title={this.props.translations["WebSMS.ResourcePlanningScheduler.Multiselect.Multiselect"]}
                                    iconName={"th-large"}
                                    handleToggle={(value) => {
                                        this._multiSelectActive = value;
                                        this.props.actions.toggleMultiSelect(value);
                                        this.setState({})
                                    }}
                                    initialValue={false}
                                    readOnly={slotActive} 
                                    value={this._multiSelectActive}
                                    shortcut={{ alt: false, ctrl: true, key: "m", shift: false }}
                                />
                                <Button
                                    buttonStyle={{ width: "64px", display: this.props.multiSelectEvents.length == 0 ? "none" : "inline-flex", borderWidth: "1px" }}
                                    text={this.props.multiSelectEvents.length.toString()}
                                    title={this.props.translations["WebSMS.ResourcePlanningScheduler.Multiselect.Action"]}
                                    handleClick={() => { }}
                                    readOnly={this.props.multiSelectEvents.length == 0}
                                    iconName={"location"}
                                    id="multiselectButton"
                                />
                                <Button
                                    buttonStyle={{ width: "64px", display: this.props.multiSelectEvents.length == 0 ? "inline-flex" : "none" }}
                                    text={this.props.multiSelectEvents.length.toString()}
                                    title={this.props.translations["WebSMS.ResourcePlanningScheduler.Multiselect.Action"]}
                                    handleClick={() => { }}
                                    readOnly={this.props.multiSelectEvents.length == 0}
                                    iconName={"location"}
                                    id="disabledMultiselectButton"
                                />
                            </>
                        }

                    </ToggleButtonGroup>
                </FilterGroup>
                <FilterGroup index={1} name={this.props.translations["WebSMS.ResourcePlanning.FilterAssignments"]} id="filterAssignments" initalOpen={true} >
                    {dropDownKNrGroupsWrapped}
                    {dropDownKNrsWrapped}
                    {multiselectFlagsWrapped}
                    {multiselectIconsWrapped}
                    <ToggleButtonGroup style={buttonGroupStyle}>
                        {buttonProjectFilter}
                        {toggleProjectFilterShowAllAssignments}
                        {buttonAddressFilter}
                        {buttonContainerFilter}
                        {toggleOnlyUnfinshed}
                    </ToggleButtonGroup>
                </FilterGroup>
                <FilterGroup index={2} name={Helper.getTranslation("WebSMS.ResourcePlanning.FilterCodes")} id="filterCodes" visibleCondition={() => { return this.props.settings.Legend.Entries.length > 0 && !this.props.deprecatedDelphiMode; }} initalOpen={false} >
                    <Legend settings={this.props.settings} onChange={this.props.onChange} events={this.props.data.Events} />
                </FilterGroup>
                <FilterGroup index={3} name={this.props.translations["Standard.Gruppieren"]} id="grouping" initalOpen={true} >
                    <ToggleButtonGroup style={inlineButtonGroupStyle}>
                        {this._createToggleFilterComponent("GroupByResources", this.props.translations["Ressource.Ressourcen"], null, this.props.settings.GroupByResources, "child")}
                        {this._createToggleFilterComponent("GroupByAddresses", this.props.translations["Adresse.Adressen"], null, this.props.settings.GroupByAddresses, "home")}
                        {this._createToggleFilterComponent("GroupByProjects", this.props.translations["Navigation.Projekte"], null, this.props.settings.GroupByProjects, "folder-open")}
                        {this._createToggleFilterComponent("GroupByMachines", this.props.translations["Field.fstasks.machines"], null, this.props.settings.GroupByMachines, "cogs")}
                    </ToggleButtonGroup>

                    {this.createShowProjectStructureCheckBox()}
                </FilterGroup>
                <FilterGroup index={4} name={this.props.translations["WebSMS.ResourcePlanning.Display"]} id="display" initalOpen={true} >
                    <ToggleButtonGroup style={inlineButtonGroupStyle}>
                        {toggleShowOnlyWorktimeWrapped}
                        {toggleShowAssignmentsWithTimeZones}
                        {toggleAutomaticUpdateWrapped}
                        {toggleShowProjectColorWrapped}
                        {toggleWholeDayAssignmentRendering}
                        {toggleAssigmentGroupingView}
                    </ToggleButtonGroup>

                    <ToggleButtonGroup style={inlineButtonGroupStyle}>
                        {toggleWorklistInTable}
                        {
                            this.props.settings.Geomap_Enabled ?
                                <ToggleButton title={this.props.translations["GeoMap.GeomapViewInPB"]} initialValue={false} value={this.props.gmToggleButtonValue} iconName="map-signs" handleToggle={this.props.actions.toggleGeomap} readOnly={slotActive} />
                                : null
                        }
                        {toggleCapacity}
                        {
                            this.props.enableHiddenEventsForCapacityToggle && this.props.settings.ProjNrs.length !== 0 ?
                            <ToggleButton title={this.props.translations["Kapazitaet.AllAssignments"]} 
                                          initialValue={this.props.settings.CapacityIgnoreProjectFilter} 
                                          iconText="FI" 
                                          handleToggle={v => this.props.actions.signalIgnoreProjectFilterInCapacity(v, true)} 
                                          readOnly={slotActive} />
                                : null
                        }
                        {toggleSlaView}
                        {toggleUtilization}
                        {toggleTargetPeriods}
                    </ToggleButtonGroup>

                    {
                        Config.settings.flagsAreActive && this.props.settings.GroupByResources && (this.props.settings.TimeResolutionType <= this._timeResolutionTypes.Days) ? (
                            <ToggleButtonGroup style={inlineButtonGroupStyle}>
                                {toggleFlagGantView}
                                {toggleFlagAssignmentView}
                            </ToggleButtonGroup>
                        ) : null
                    }

                    <ToggleButtonGroup style={inlineButtonGroupStyle}>
                        {toggleDegreeOfCompletion}
                        {toggleAssignmentMoveVerticalFixedWrapped}
                        {toggleAssignmentMoveHorizontalFixedWrapped}
                    </ToggleButtonGroup>
                </FilterGroup>

                {this._createContextMenu()}
            </div>;

        return ReactDOM.createPortal(portal, this._sheetRef[0]);
    }
}

type SettingsKey = keyof ResourcePlanningSchedulerSettingsViewModel;

export interface OnChangeField {
    model: keyof ResourcePlanningSchedulerSettingsViewModel;
}
interface SettingsProps {
    settings: ResourcePlanningSchedulerSettingsViewModel;
    data: ResourcePlanningSchedulerDataViewModel;
    dataSources: { resstypenDS: any };
    translations: StringKeyDictionary<string>;
    actions: ResourcePlanningSchedulerActions;
    onChange?: (field: OnChangeField | Array<OnChangeField>, value: any | Array<any>, dataItem?: any, setSchedulertoStartDate?: boolean) => void;
    commandManager: CommandManagerAPI;
    enableHiddenEventsForCapacityToggle: boolean;
    gmToggleButtonValue: boolean;
    capacityActive: boolean;
    // slotModeActive: boolean;
    interactiveSlotModeActive: boolean;
    onGraphicalFocussingChange: GraphicalFocussingHandling;
    //slaViewActive: boolean;
    multiSelectEvents: Array<ResourcePlanningSchedulerEventViewModel>;
    openExternalInfos?: OpenExternalInfo[];
    onFavoriteFilterChange: (settings: ResourcePlanningSchedulerSettingsViewModel) => Promise<void>;
    dropDownFilterOptions: DropDownFilterOptions;
    deprecatedDelphiMode: boolean;
    handleEval:(action: any, prepare?: any) => any;
}

interface GraphicalFocussingHandling {
    onForward: (searchType: SearchType, value: string) => void;
    onBackward: (searchType: SearchType, value: string) => void;
    onChange: (searchType: SearchType, value: string) => void;
}



export interface OpenExternalInfo {
    title: string;
    statisticId: string;
    url: string;
    mapping: StringKeyDictionary<string>;
    openInNewTab: boolean;
}

interface FilterGroupProps extends React.PropsWithChildren {
    name: string;
    index: number;
    id: string;
    visibleCondition?: () => boolean;
    initalOpen: boolean;
}


function FilterGroup(props: FilterGroupProps) {
    const saveId = `FilterGroup_${props.id}_${Config.user.userName}`;
    let initOpen = props.initalOpen;
    const tmp = Helper.loadDataFromStorage(saveId)
    if (Helper.hasValue(tmp)) {
        initOpen = tmp;
    }
    const [open, setOpen] = React.useState(initOpen);
    const [mounted, setMounted] = React.useState(false)


    if (Helper.hasValue(props.visibleCondition) && !props.visibleCondition()) {
        return null;
    }

    function toggle() {
        Helper.saveDataToStorage(saveId, !open, false);
        setOpen(!open);
    }

    React.useEffect(() => {
        setMounted(true);
    }, [])

    return (
        <div className={"filter_group " + (open ? "open" : "") + (mounted ? " mounted" : "")} >
            <div className="filter_group__button" onClick={toggle}>
                <label>{props.name}</label>
                <i className="fa-solid fa-caret-down"></i>
            </div>
            <div className="filter_group__items">
                {props.children}
            </div>
        </div>
    );
}

